module.exports = __webpack_public_path__ + "img/product-atomizer-kangertech-ULTRA_BAR.2c77f4fd.jpg";